var map = {
	"./bg-exclusive.webp": 1347,
	"./border-bg-sm.png": 1348,
	"./border-bg-xm.png": 1349,
	"./border-bg.png": 1350,
	"./btn-active.png": 1351,
	"./casino-hover.webp": 1352,
	"./cny-flower-1.webp": 1353,
	"./cny-flower-2.webp": 1354,
	"./cny-mobile-bg.webp": 1355,
	"./content-deco-1.webp": 1356,
	"./content-deco-2.webp": 1357,
	"./content-deco-3.webp": 1358,
	"./content-deco-4.webp": 1359,
	"./content-deco-5.webp": 1360,
	"./deposit-icon.webp": 1361,
	"./event-border-hover.webp": 1362,
	"./games-hover.webp": 1363,
	"./home-icon-active.webp": 1364,
	"./home-icon.webp": 1365,
	"./live-icon-active.webp": 1366,
	"./live-icon.webp": 1367,
	"./lottery-hover.webp": 1368,
	"./master-bg.png": 1369,
	"./me-icon-active.webp": 1370,
	"./me-icon.webp": 1371,
	"./p2p-hover.webp": 1372,
	"./platform.webp": 1373,
	"./product-overview-bg.webp": 1374,
	"./promos-icon-active.webp": 1375,
	"./promos-icon.webp": 1376,
	"./slots-hover.webp": 1377,
	"./sponsor-icon-active.webp": 1378,
	"./sponsor-icon.webp": 1379,
	"./sports-hover.webp": 1380,
	"./title-deco-bg.webp": 1381,
	"./title-deco-left.webp": 1382,
	"./title-deco-right.webp": 1383,
	"./vip-icon-active.webp": 1384,
	"./vip-icon.webp": 1385,
	"./withdraw-icon.webp": 1386,
	"./wwr-bg.webp": 1387,
	"./wwr-img.webp": 1388
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 150;